export default __webpack_public_path__ + "9ca11cf6ac3a549b4536fade66fbb052.jpg";